export default __webpack_public_path__ + "static/media/gy.0888273d.svg";